import Navbar from "./Navbar";
import Footer from "./Footer";
import StickyContactBar from "@/components/StickyContactBar";
import TrustStrip, { TrustStripMobile } from "@/components/TrustStrip";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      <Navbar />
      <TrustStrip />
      <TrustStripMobile />
      {/* Extra bottom padding on mobile so sticky bar doesn't cover content */}
      <main className="flex-1 pb-20 lg:pb-0 w-full">{children}</main>
      <Footer />
      <StickyContactBar />
    </div>
  );
}
